import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import Navbar from './navbar'
import Intro from './intro'
import Pagenotfound from './404'
import Skills from './skills'
import Projects from './projects'
import Achieve from './achievements'
import Responsibility from './responsible'
import Connect from './connect'

export class header extends Component {
  render () {
    return (
      <>
        <Navbar />
        <Switch>
          <Route exact path='/' component={Intro} />
          <Route path='/skills' component={Skills} />
          <Route path='/projects' component={Projects} />
          <Route path='/achievements' component={Achieve} />
          <Route path='/positions_of_responsibilities' component={Responsibility} />
          <Route path='/connectwith_abhinav' component={Connect} />
          <Route path='/404' component={Pagenotfound} />
          <Redirect to='/404' />
        </Switch>
      </>
    )
  }
}

export default header
